import { Box, Icon, Link } from "@/components/atoms";
import { FC, memo, useCallback } from "react";

import FloorPlan from "../../Order/Cards/OrderService/FloorPlan";
import GenericCustomerService from "../../Order/Cards/OrderService/GenericCustomerService";
import { HelpModal } from "@/components/organisms/Modais/HelpModal";
import { LogoParams } from "@/api/order/interface";
import { NATURAL } from "@/theme";
import { OrderCustomerProps } from "../OrderCustomer.interface";
import Photo from "../../Order/Cards/OrderService/Photo";
import WalklyService from "../../Order/Cards/OrderService/WalklyService";
import { getGroupedOrderServices } from "@/helpers";
import { useModal } from "@/hooks";

const ContentSelected: FC<OrderCustomerProps> = ({
    hasLogo,
    logoUrl,
    onChooseDraftFiles,
    onConfirmFiles,
    onDownloadFiles,
    onShareVideo,
    orderDetails,
}) => {
    const { showModal: showHelpModal, onCloseModal: onCloseHelpModal, onOpenModal: onOpenHelpModal } = useModal();

    const url = "https://share.getcloudapp.com/WnumjZzb";
    const embedUrl = `${url}?embed=true&amp;title=true`;

    const handleHelpClick = useCallback((e) => {
        e.stopPropagation();
        onOpenHelpModal();
    }, []);

    const handleDownloadFiles = (serviceId: string, filesId: string[], isDraft: boolean, resolutions?: string[], logoParams?: LogoParams) => {
        onDownloadFiles(serviceId, filesId, isDraft, resolutions, logoParams);
    }

  const { photoService, floorPlanService, virtualTourService, virtualStagingService, imagemotionVideoService, walklyService, remainingServices } = getGroupedOrderServices(orderDetails?.services || []);

    const customerServices = [virtualTourService, virtualStagingService, imagemotionVideoService,  ...remainingServices ];


    return (<>
        <Box margin="10px 0px">
            <Icon type="question" fillColor={NATURAL.K} display="inline-block"/>
            <Link underline={true} onClick={handleHelpClick}>Click here for video guide</Link>
        </Box>
        {photoService && <Photo
            branchId={orderDetails.branchId}
            amount={photoService.amount}
            draftFiles={photoService.draftUploadFiles}
            hasLogo={hasLogo}
            logoUrl={logoUrl}
            name={photoService.name}
            notifications={photoService.notifications}
            orderId={orderDetails.id}
            orderPrice={orderDetails.orderPrice}
            orderState={orderDetails.orderState}
            selectedWorkerName={photoService.applicationUserName}
            serviceId={photoService.orderServiceId}
            type={photoService.type}
            uploadedFiles={photoService.uploadFiles}
            onConfirmFiles={onConfirmFiles}
            onDownloadFiles={handleDownloadFiles}
            onChooseDraftFiles={onChooseDraftFiles}
        /> }

        {floorPlanService && <FloorPlan
            draftFiles={floorPlanService.draftUploadFiles}
            logoUrl={logoUrl}
            name={floorPlanService.name}
            notifications={floorPlanService.notifications}
            orderState={orderDetails.orderState}
            selectedWorkerName={floorPlanService.applicationUserName}
            serviceId={floorPlanService.orderServiceId}
            type={floorPlanService.type}
            uploadedFiles={floorPlanService.uploadFiles}
            onDownloadFiles={onDownloadFiles}
        /> }
                
        {walklyService && <WalklyService
                externalUrl={walklyService.externalLink || ''}
                label={walklyService.label || "{}"}
                name={walklyService.name}
                onShareVideo={onShareVideo}
                orderId={orderDetails.id}
                selectedWorkerName={walklyService.applicationUserName}
                serviceId={walklyService.orderServiceId}
                type={walklyService.type}
                uploadedFiles={walklyService.uploadFiles}
                />
        }
        
        { customerServices.map((item) => {
            return item && (
                <GenericCustomerService
                    key={item.orderServiceId}
                    label={item.label || 'Link'}
                    name={item.name}
                    notifications={item.notifications}
                    externalUrl={item.externalLink || ''}
                    selectedWorkerName={''}
                    serviceId={item.orderServiceId}
                    type={item.type}
                        />
            );
        })}

          {showHelpModal && (
            <HelpModal
              onClose={onCloseHelpModal}
              url={url}
              embedUrl={embedUrl}
            />
          )}
    </>)
}

export default memo(ContentSelected);